__turbopack_context__.v({
  "banner": "about-us-module-scss-module__bpVoVW__banner",
  "bannerImg": "about-us-module-scss-module__bpVoVW__bannerImg",
  "bannerOverlay": "about-us-module-scss-module__bpVoVW__bannerOverlay",
  "bannerTitle": "about-us-module-scss-module__bpVoVW__bannerTitle",
  "board": "about-us-module-scss-module__bpVoVW__board",
  "cardButton": "about-us-module-scss-module__bpVoVW__cardButton",
  "inlineBullet": "about-us-module-scss-module__bpVoVW__inlineBullet",
  "inlineCard": "about-us-module-scss-module__bpVoVW__inlineCard",
  "inlineDetails": "about-us-module-scss-module__bpVoVW__inlineDetails",
  "inlinePortrait": "about-us-module-scss-module__bpVoVW__inlinePortrait",
  "inlineText": "about-us-module-scss-module__bpVoVW__inlineText",
  "networkContent": "about-us-module-scss-module__bpVoVW__networkContent",
  "networkLead": "about-us-module-scss-module__bpVoVW__networkLead",
  "networkSection": "about-us-module-scss-module__bpVoVW__networkSection",
  "networkTitle": "about-us-module-scss-module__bpVoVW__networkTitle",
  "page": "about-us-module-scss-module__bpVoVW__page",
  "partnerButton": "about-us-module-scss-module__bpVoVW__partnerButton",
  "partnerImageContainer": "about-us-module-scss-module__bpVoVW__partnerImageContainer",
  "portraitFrame": "about-us-module-scss-module__bpVoVW__portraitFrame",
  "portraitFrameLg": "about-us-module-scss-module__bpVoVW__portraitFrameLg",
  "portraitImg": "about-us-module-scss-module__bpVoVW__portraitImg",
  "sectionTitle": "about-us-module-scss-module__bpVoVW__sectionTitle",
  "stripScroller": "about-us-module-scss-module__bpVoVW__stripScroller",
  "team": "about-us-module-scss-module__bpVoVW__team",
  "teamCard": "about-us-module-scss-module__bpVoVW__teamCard",
  "teamScroller": "about-us-module-scss-module__bpVoVW__teamScroller",
  "teamStrip": "about-us-module-scss-module__bpVoVW__teamStrip",
  "threeLineEllipse": "about-us-module-scss-module__bpVoVW__threeLineEllipse",
  "timeline": "about-us-module-scss-module__bpVoVW__timeline",
  "timelineLine": "about-us-module-scss-module__bpVoVW__timelineLine",
  "timelineScroller": "about-us-module-scss-module__bpVoVW__timelineScroller",
});
